// stores/toastStore.ts
import { defineStore } from "pinia";
import { ref } from "vue";

export const useToastStore = defineStore("toast", () => {
    const toasts = ref<{ id: string; title: string; content: string }[]>([]);

    // Toast 추가
    const addToast = (title: string, content: string) => {
        const id = Date.now().toString(); // 고유 ID 생성
        // toasts.value.push({ id, title, content });
        toasts.value = [...toasts.value, { id, title, content }]

        // 일정 시간이 지나면 자동으로 제거
        setTimeout(() => removeToast(id), 5000); // 3초 후 제거
    };

    // Toast 제거
    const removeToast = (id: string) => {
        toasts.value = toasts.value.filter((toast) => toast.id !== id);
    };

    return { toasts, addToast, removeToast };
});
